export const PORTAL_NAVIGATION_BOX_PORTAL_ID = 'portal-navigation-box';
export const PORTAL_NAVIGATION_BOX_PORTAL_EVENT = 'portalnavigationboxready';
export const PORTAL_NAVIGATION_KEY = 'portal-navigation';

export enum PortalNavigationVariants {
  INLINE = 'inline',
  DROPDOWN = 'dropdown',
}

export const PORTAL_NAV_BOX_HEADER_ID = 'portal-navigation-header-box';
export const PORTAL_NAV_BOX_HEADER_EVENT = 'portalnavigationheader:ready';

export const PORTAL_NAX_LOADED_EVENT = 'portalnavigationheader:loaded';
